<template>
<w-sliding-popup ref="slidingPopup" type="setting" :title="targetTitle" width="950px">
  <div slot="content">
    <el-form :model="formData" label-position="top" ref="alarmPopForm" class="mr-b25">
      <el-row>
        <el-form-item label="템플릿 ID" prop="alarmRepeatId" :rules="{ required: true, trigger: 'blur', message: '값을 입력해주세요' }">
          <el-input :disabled="!(slidingPopupStatus === 'add')" v-model="formData.alarmRepeatId" placeholder="입력해주세요"></el-input>
        </el-form-item>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="템플릿명" prop="alarmRepeatName" :rules="{ required: true, trigger: 'blur', message: '값을 입력해주세요' }">
            <el-input v-model="formData.alarmRepeatName" placeholder="입력해주세요"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="알람 반복 주기(분)" prop="alarmRepeatInterval">
            <el-input-number controls-position="right" v-model="formData.alarmRepeatInterval" :min="1" :max="999" style="width: 100%;"></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <hr class="mr-t25 mr-b25"/>
    <el-row type="flex" justify="space-between">
      <div class="title-bar title-h4 dot-title">2차 알림 설정</div>
      <el-switch v-model="formData.alarmRepeat2ndApplyFlag" @change="alarm2ndFlagChange" active-value="Y" inactive-value="N"></el-switch>
    </el-row>
    <el-form class="mr-b25" :model="formData" label-position="top" :disabled="!(formData.alarmRepeat2ndApplyFlag === 'Y')">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="2차 알림 발생 조건" prop="alarmRepeat2ndMinute">
            <el-input-number style="float: left;" v-model="formData.alarmRepeat2ndMinute" controls-position="right" :min="1" :max="999"></el-input-number>
            <div style="float: left; padding-left: 10px;">
              <span style="display: block;">분 이후</span>
              <span style="font-size: 10px;">(최초 이벤트 발생 후)</span>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="2차 알람 수신자" prop="alarmRepeat2ndManagerId" :rules="{ required: true, trigger: 'blur', message: '값을 입력해주세요' }">
            <el-select v-model="formData.alarmRepeat2ndManagerId" filterable default-first-option style="width: 100%;">
              <el-option v-for="item in userListForSelectData" :key="item.managerId" :label="`[${item.grade}] ${item.managerName}`" :value="item.managerId"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <hr class="mr-t25 mr-b25"/>
    <el-row type="flex" justify="space-between">
      <div class="title-bar title-h4 dot-title">3차 알림 설정</div>
      <el-switch :disabled="!(formData.alarmRepeat2ndApplyFlag === 'Y')" v-model="formData.alarmRepeat3rdApplyFlag" active-value="Y" inactive-value="N"></el-switch>
    </el-row>
    <el-form label-position="top" :disabled="!(formData.alarmRepeat3rdApplyFlag === 'Y')">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="3차 알림 발생 조건" prop="alarmRepeat3rdMinute">
            <el-input-number style="float: left;" v-model="formData.alarmRepeat3rdMinute" controls-position="right" :min="1" :max="999"></el-input-number>
            <div style="float: left; padding-left: 10px;">
              <span style="display: block; ">분 이후</span>
              <span style="font-size: 10px;">(최초 이벤트 발생 후)</span>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="3차 알람 수신자" prop="alarmRepeat3rdManagerId">
            <el-select v-model="formData.alarmRepeat3rdManagerId" filterable default-first-option style="width: 100%;">
              <el-option v-for="item in userListForSelectData" :key="item.managerId" :label="`[${item.grade}] ${item.managerName}`" :value="item.managerId"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
  <el-row slot="footer" type="flex" justify="center">
    <el-button size="large" type="solid" class="mr-r4" @click="onTemplateAddButton">저장</el-button>
    <el-button size="large" @click="clickCloseBtn">취소</el-button>
  </el-row>
</w-sliding-popup>
</template>

<script>
import msgUtil from '@/utils/message';
import UserSettingApi from '@/api/settings/user/user-setting';
import { forEach, cloneDeep } from 'lodash';
import OperationSettingsAPI from '@/api/settings/common/operation-settings';

export default {
  name: 'WAlarmTemplateAddSlidingPopup',
  data() {
    return {
      formData: {
        alarmRepeatId: '', // 템플릿 아이디
        alarmRepeatName: '', // 템플릿 이름
        alarmRepeatInterval: 1,
        alarmRepeat2ndApplyFlag: 'N', // 2차 알람 플래그
        alarmRepeat2ndMinute: 1,
        alarmRepeat2ndManagerId: '',
        alarmRepeat3rdApplyFlag: 'N', // 3차 알람 플래그
        alarmRepeat3rdMinute: 1,
        alarmRepeat3rdManagerId: '',
      },
      userListForSelectData: [],
      slidingPopupStatus: '',
      targetTitle: '',
    };
  },
  mounted() {
    // 사용자 정보 api 호출
    UserSettingApi.getUserList({ activeStatus: 'Y' }).then((response) => {
      this.userListForSelectData = response.data.data;
      this.$nextTick(() => {
        this.alarmRepeat2ndManagerId = this.userListForSelectData[0].managerId;
        this.alarmRepeat3rdManagerId = this.userListForSelectData[0].managerId;
      });
    });
  },
  methods: {
    open(payload) {
      const targetData = cloneDeep(payload);
      this.$refs.slidingPopup.open();
      this.$nextTick(() => {
        this.$refs.alarmPopForm.resetFields();
        // formData 초기화
        this.formData = {
          alarmRepeatId: '',
          alarmRepeatName: '',
          alarmRepeatInterval: 1,
          alarmRepeat2ndApplyFlag: 'N',
          alarmRepeat2ndMinute: 1,
          alarmRepeat2ndManagerId: this.userListForSelectData[0].managerId,
          alarmRepeat3rdApplyFlag: 'N',
          alarmRepeat3rdMinute: '',
          alarmRepeat3rdManagerId: this.userListForSelectData[0].managerId,
        };
        // 추가 팝업인지 수정 팝업인지 구분
        if (targetData) {
          this.slidingPopupStatus = 'update';
          this.targetTitle = `[${targetData.alarmRepeatName}] 템플릿 정보`;
          forEach(this.formData, (item, key) => {
            if (!targetData[key]) {
              targetData[key] = item;
            }
          });
          this.formData = targetData;
        } else {
          this.slidingPopupStatus = 'add';
          this.targetTitle = '알람 순차발송 템플릿 추가';
        }
      });
    },
    // close 버튼 클릭
    clickCloseBtn() {
      this.$refs.slidingPopup.close();
    },
    onTemplateAddButton() {
      const target = '템플릿 정보';
      this.$refs.alarmPopForm.validate((valid) => {
        if (valid) {
          // 플래그가 'Y'인 대상만을 파라미터로 보낸다.
          if (this.formData.alarmRepeat2ndApplyFlag === 'N') {
            delete this.formData.alarmRepeat2ndMinute;
            delete this.formData.alarmRepeat2ndManagerId;
            delete this.formData.alarmRepeat2ndManagerName;
          }
          if (this.formData.alarmRepeat3rdApplyFlag === 'N') {
            delete this.formData.alarmRepeat3rdMinute;
            delete this.formData.alarmRepeat3rdManagerId;
            delete this.formData.alarmRepeat3rdManagerName;
          }
          if (this.slidingPopupStatus === 'add') {
            OperationSettingsAPI.addAlarmTemplate(this.formData).then((response) => {
              if (response.data.success) {
                this.$emit('load-data');
                this.$message(msgUtil.getResultMsgData(msgUtil.action.SAVE, target, true));
                this.clickCloseBtn();
              } else {
                this.$message(msgUtil.getResultMsgData(msgUtil.action.SAVE, target, false));
              }
            });
          } else {
            // update api 호출
            OperationSettingsAPI.updateAlarmTemplate(this.formData).then((response) => {
              if (response.data.success) {
                this.$emit('load-data');
                this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, target, true));
                this.clickCloseBtn();
              }
            });
          }
        }
      });
    },
    // 2차 설정이 false될 경우 3차도 함께 false 세팅한다.
    alarm2ndFlagChange(value) {
      if (value === 'N') {
        this.formData.alarmRepeat3rdApplyFlag = 'N';
      }
    },
  },
};
</script>

<style scoped>
.alarm-template-title {
  padding-top: 30px;
}
.alarm-compo-title {
  display: block;
  font-weight: bold;
  font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/views/settings/operation/EventAlarmSettings/AlarmSettings/popup/AlarmTemplateAddSlidingPopup.vue